export const Faq = [
	{
		heading:
			'Co obejmuje program ubezpieczeń zawodowych dla ratowników WOPR?',
		content: [
			'Program zapewnia ubezpieczenie odpowiedzialności cywilnej (OC) oraz ubezpieczenie następstw nieszczęśliwych wypadków (NNW). W razie potrzeby ubezpieczenie OC można rozszerzyć w zakresie terytorialnym na cały świat oraz o klauzulę kosztów ochrony prawnej na terenie Polski.',
		],
	},
	{
		heading:
			'W jakim towarzystwie ubezpieczeniowym zawierane jest ubezpieczenie?',
		content: ['Za ochronę ubezpieczeniową odpowiada STU Ergo Hestia S.A.'],
	},
	{
		heading:
			'Kto może skorzystać z oferty dostępnej w serwisie wopr.mentor.pl?',
		content: [
			'Program ubezpieczeń dostępny na stronie wopr.mentor.pl jest adresowany wyłącznie do ratowników Wodnego Ochotniczego Pogotowia Ratunkowego.',
		],
	},
	{
		heading: 'Jak mogę się ubezpieczyć?',
		content: [
			'Do programu ubezpieczeń możesz przystąpić online, wypełniając formularz dostępny na tej stronie internetowej. Postępuj zgodnie z instrukcjami. Proces przystąpienia jest w pełni zautomatyzowany i intuicyjny – krok po kroku przeprowadzimy Cię przez wszystkie jego etapy.',
		],
	},
	{
		heading: 'Czy muszę odesłać podpisaną deklarację ubezpieczeniową?',
		content: [
			'Nie, cały proces przystępowania do ubezpieczenia odbywa się online.',
		],
	},
	{
		heading: 'Ile czasu trwa ochrona?',
		content: ['Ochrona ubezpieczeniowa trwa 12 miesięcy'],
	},
	{
		heading:
			'Z jakimi dokumentami należy się zapoznać przed przystąpieniem do ubezpieczenia?',
		content: [
			'Zalecamy dokładne zapoznanie się z Programem ubezpieczeń, Warunkami Ubezpieczenia Odpowiedzialności Cywilnej z tytułu wykonywania czynności zawodowych (B), kod: OC/OW060/2108, Ogólnymi Warunkami Ubezpieczenia Biznes & Podróż z dnia 1 sierpnia 2021 r. (kod: PAT/OW071/2108) oraz Regulaminem serwisu wopr.mentor.pl.',
		],
	},
	{
		heading: 'Gdzie znajdę warunki ubezpieczenia?',
		content: [
			'Znajdziesz je w zakładce Dokumenty oraz w zakresie każdego z ubezpieczeń na stronie głównej.',
		],
	},
	{
		heading: 'W jaki sposób mogę zapłacić za ubezpieczenie?',
		content: [
			'Składkę ubezpieczeniową możesz opłacić korzystając z jednej z form płatności online dostępnych na końcu procesu przystąpienia do programu ubezpieczeń.',
		],
	},
	{
		heading: 'Czy płatność można rozłożyć na raty?',
		content: [
			'Płatność jest realizowana z góry za cały okres ubezpieczenia. Zakład ubezpieczeń nie dopuszcza możliwości rozłożenia płatności na raty.',
		],
	},
	{
		heading: 'Od kiedy zacznie działać ubezpieczenie?',
		content: [
			'Ochrona ubezpieczeniowa trwa od dnia wskazanego w formularzu przystąpienia, pod warunkiem opłacenia składki w terminie. Jest on również podany w certyfikacie ubezpieczeniowym.',
		],
	},
	{
		heading:
			'Co mogę zrobić w przypadku podania błędnych danych lub konieczności ich zmiany?',
		content: [
			'Informację w tym zakresie należy przesłać drogą mailową na adres: wopr@mentor.pl',
		],
	},
	{
		heading: 'Co to jest ubezpieczenie NNW?',
		content: [
			'Jest to ubezpieczenie następstw nieszczęśliwych wypadków, które zapewnia wsparcie finansowe w razie doznania nieszczęśliwego wypadku lub śmierci ubezpieczonego. W tym ostatnim przypadku świadczenie jest wypłacane zgodnie z masą spadkową.',
		],
	},
	{
		heading:
			'Czy ubezpieczenie NNW obowiązuje tylko w trakcie wykonywania pracy?',
		content: [
			'Zakres czasowy ubezpieczenia NNW jest uzależniony od wyboru spośród poniższych wariantów ochrony:',
			'* wariant całodobowy – obejmuje odpowiedzialność ubezpieczyciela za następstwa nieszczęśliwych wypadków doznanych przez ubezpieczonego podczas wykonywania pracy ratownika WOPR, w drodze do i z pracy oraz w życiu prywatnym;',
			'* wariant ograniczony – obejmuje odpowiedzialność ubezpieczyciela za następstwa nieszczęśliwych wypadków doznanych przez ubezpieczonego podczas wykonywania pracy ratownika WOPR oraz w drodze do i z pracy.',
		],
	},
	{
		heading:
			'Co mieści się w zakresie ubezpieczenia assistance wchodzącego w skład ubezpieczenia NNW?',
		content: [
			'W zakresie ubezpieczenia assistance mieszczą się następujące usługi assistance po nieszczęśliwym wypadku: wizyta lekarza, wizyta pielęgniarki, dostarczenie do miejsca pobytu leków przepisanych przez lekarza, transport z miejsca pobytu ubezpieczonego do placówki medycznej, transport z placówki medycznej do miejsca pobytu ubezpieczonego, pomoc domowa, pomoc psychologiczna, opieka nad dziećmi, organizacja opieki nad psami i kotami ubezpieczonego znajdującymi się w jego domu, informacje o służbie zdrowia, powiadomienie o zaistniałym zdarzeniu rodziny oraz zakładu pracy ubezpieczonego, korepetycje, funeral assistance (limity ilościowe oraz kwotowe dla poszczególnych usług assistance są określone w Ogólnych Warunkach Ubezpieczenia). Usługi te są realizowane na terenie Polski.',
		],
	},
	{
		heading: 'Co to jest ubezpieczenie OC?',
		content: [
			'Jest to ubezpieczenie odpowiedzialności cywilnej ratownika WOPR za szkody na osobie oraz szkody w mieniu wyrządzone osobom trzecim w związku z wykonywaniem czynności zawodowych.',
		],
	},
	{
		heading: 'Co to jest klauzula kosztów ochrony prawnej?',
		content: [
			'Jest to rozszerzenie do ubezpieczenia odpowiedzialności cywilnej, które obejmuje koszty ochrony prawnej poniesione przez ubezpieczonego w postępowaniu wszczętym na terenie RP w okresie ubezpieczenia, o ile dotyczy ono czynności zawodowych ubezpieczonego przyjętych do ubezpieczenia na podstawie niniejszej umowy.',
		],
	},
	{
		heading:
			'Czy mogę skorzystać z samej klauzuli kosztów ochrony prawnej?',
		content: [
			'Klauzula kosztów ochrony prawnej stanowi rozszerzenie do ubezpieczenia odpowiedzialności cywilnej. Oznacza to, że konieczne jest przystąpienie do ubezpieczenia odpowiedzialności cywilnej, aby móc skorzystać z ochrony zapewnianej w ramach tej klauzuli.',
		],
	},
	{
		heading: 'Gdzie znajdę informacje o sposobach zgłoszenia szkody?',
		content: ['Znajdziesz je w zakładce Zgłoszenie Szkody.'],
	},
	{
		heading:
			'Gdzie znajdę formularze do zgłoszenia wypadku ubezpieczeniowego?',
		content: ['Znajdziesz je w zakładce Zgłoszenie Szkody lub Dokumenty.'],
	},
];
